/**
 * lib/numbering.ts — gapless document numbers via a Firestore transaction.
 * GH-INV-0001 for invoices, GH-REC-0001 for receipts, GH-QUO-0001 for quotes.
 */
import { doc, runTransaction } from 'firebase/firestore';
import { db } from './firebase';

type DocKind = 'invoice' | 'receipt' | 'quotation';

const PREFIX: Record<DocKind, string> = {
  invoice: 'GH-INV',
  receipt: 'GH-REC',
  quotation: 'GH-QUO',
};

export async function nextNumber(kind: DocKind): Promise<string> {
  const ref = doc(db, 'counters', kind);
  const seq = await runTransaction(db, async (tx) => {
    const snap = await tx.get(ref);
    const current = snap.exists() ? Number(snap.data().seq || 0) : 0;
    const next = current + 1;
    tx.set(ref, { seq: next, updatedAt: new Date().toISOString() }, { merge: true });
    return next;
  });
  return `${PREFIX[kind]}-${String(seq).padStart(4, '0')}`;
}
